import React from 'react';

interface DomainsIconProps {
    isActive?: boolean;
}

const DomainsIcon: React.FC<DomainsIconProps> = ({ isActive = false }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
                cx="8"
                cy="8"
                r="6.5"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
            />
            <path d="M1.5 8H14.5" stroke="currentColor" strokeLinecap="round"/>
            <ellipse cx="8" cy="8" rx="2.8" ry="6.5" stroke="currentColor" fill="none"/>
        </svg>
    );
};

export default DomainsIcon;
